import { RewardOverviewSkeleton } from './RewardOverviewSkeleton'

type Props = {
  /** 表示するスケルトン行数（デフォルト: 5） */
  count?: number
}

export function RewardListSkeleton({ count = 5 }: Props) {
  return (
    <ul className="divide-y divide-gray-100">
      {Array.from({ length: count }).map((_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: 静的なスケルトン行のため index を key に使用
        <li key={i}>
          <RewardOverviewSkeleton />
        </li>
      ))}
    </ul>
  )
}
